<template>
  <div>
    <div class="holdingContainer rounded">
      <div class="ml-4 mt-1">
        <input
          type="checkbox"
          class="bgc-checkbox"
          id="check1"
          v-model="crossSellData.isCrossSellSelected"
          @click="crossSellSelected()"
        />
        <label class="form-check-label d-flex mb-2" for="check1">
          <p class="pl-4 font-weight-bold h6">
            Buy Additional Health Insurance Plans<span class="startingHealth">
              starting Rs.300</span
            >
          </p>
        </label>
      </div>
      <div v-if="crossSellData.isCrossSellSelected">
        <hr />
        <div class="d-flex ml-4 row w-95 mb-4">
          <div class="form-group col-lg-3 col-md-3 col-sm-6 p-0">
            <float-label label="Date of Birth*" :fixed="isFloat(crossSellData.dateOfBirth.value)">
              <datepicker
                format="dd/MM/yyyy"
                placeholder="Date of Birth*"
                :typeable="true"
                :input-class="isInputError(crossSellData.dateOfBirth.errorText)"
                @datePickerBlurred="checkError(crossSellData.dateOfBirth,false)"
                v-model="crossSellData.dateOfBirth.value"
              ></datepicker>
            </float-label>
            <span
              class="error-text"
              v-if="crossSellData.dateOfBirth.errorText!==''"
            >{{crossSellData.dateOfBirth.errorText}}</span>
          </div>
          <div class="form-group col-lg-3 col-md-3 col-sm-6 p-0">
            <float-label label="Gross Monthly Income*" :fixed="isFloat(crossSellData.grossMonthlyIncome.value)">
              <input
                type="text"
                placeholder="Gross Monthly Income*"
                class="form-control"
                v-on:keydown="onlyNumber"
                v-model="crossSellData.grossMonthlyIncome.value"
                :class="{ 'bgc-error-field': crossSellData.grossMonthlyIncome.errorText!=='' }"
                v-evolvews="crossSellData.grossMonthlyIncome"
              />
            </float-label>
            <span
              class="error-text"
              v-if="crossSellData.grossMonthlyIncome.errorText!==''"
            >{{crossSellData.grossMonthlyIncome.errorText}}</span>
          </div>
          <div class="form-group col-lg-3 col-md-3 col-sm-6 p-0">
            <float-label label="Occupation*" :fixed="isFloat(crossSellData.occupation.value)">
              <select 
                  class="form-control" 
                  placeholder="Occupation*" 
                  :class="{ 'bgc-error-field': crossSellData.occupation.errorText!=='' }"
                  v-evolvews="crossSellData.occupation"
                  v-model="crossSellData.occupation.value"
              >
                <option disabled value>Occupation*</option>
                <option>Businessman</option>
                <option>TCSer</option>
                <option>TCSer</option>
              </select>
            </float-label>
            <span class="error-text" v-if="crossSellData.occupation.errorText !== ''">
              {{ crossSellData.occupation.errorText }}
            </span>
          </div>
          <div class="form-group col-lg-3 col-md-3 col-sm-6 p-0">
            <!-- <button
              class="mt-0 float-lg-right get-Health-Plans bgc-btn-primary"
              @click="showPlanHealth()"
              type="button"
            >
              Get Health Plans
            </button> -->
            <button
            :disabled="crossSellData.occupation.value =='' || crossSellData.dateOfBirth.value =='' || crossSellData.grossMonthlyIncome.value ==''"
            class="bgc-btn-primary mt-0 float-lg-right get-Health-Plans"
            type="button"
            @click="showPlanHealth()"
             id="get-health-plans"
          >Get Health Plans</button>
          </div>
        </div>
      <div v-if="state.showPlans || checkMotorParent">
        <div class="position-relative pl-4 pt-4 pb-1 font-weight-light small">*You can add more than one Health Plan</div>
        <div class="row p-4">
          <!-- Global Personal Guard starts here -->
          <div class="col-lg-4 col-md-12 col-sm-12 mobile-padding">
            <div
              class="p-3 border-card rounded mb-1"
              :class="{ checked: state.globalPersonalGaurd }"
            >
              <!-- <div class="d-flex">

              <div class="pl-1">
                <span class="card-header-color font-weight-bold"
                  >Hospital Cash</span
                >
              </div>
                          <div class="ml-auto">
                <input type="checkbox" class="bgc-checkbox" id="check3" />
                <label
                  class="checkbox-inline form-check-label d-flex justify-content-left"
                  for="check3"
                ></label>
              </div>
            </div> -->
              <div class="d-flex">
                <div class="pt-1">
                  <span class="card-header-color font-weight-bold"
                    >Global Personal Guard</span
                  >
                </div>
                <div class="ml-auto">
                  <input
                    type="checkbox"
                    class="bgc-checkbox"
                    id="check2"
                    value="globalPersonalGuard"
                    v-model="crossSellData.healthPlans"
                    @click="checkGlobalPersonalGaurd()"
                  />
                  <label
                    class="checkbox-inline form-check-label d-flex justify-content-left"
                    for="check2"
                  ></label>
                </div>
              </div>
              <div class="pt-4 sum-insured">
                <span class="mb-0 font-weight-bold">SUM INSURED </span>
              </div>
              <div class="header-underline pt-2"></div>
              <div class="row breakup-row">
                <div class="col-2 d-flex pr-0 mr-0 w-0">
                  <span>₹450,000 </span>
                </div>
                <div class="col-2 pl-3 pl-lg-1 pl-md-1 pr-0 mt-1 discriptionFigure">
                  <span> Death</span>
                </div>
                <div class="col-2 d-flex m-0 p-0 max-width-amount">
                  <span>₹4,500</span>
                </div>
                <div class="col-5 pl-1 pr-0 mt-1 discriptionFigure">
                  <span>Transportation of Mortal Remains</span>
                </div>
              </div>
              <div class="row breakup-row">
                <div class="col-2 d-flex pr-0 mr-0 w-0">
                  <span>₹450,000 </span>
                </div>
                <div class="col-2 pl-3 pl-lg-1 pl-md-1 pr-0 mt-1 discriptionFigure">
                  <span> PTD</span>
                </div>
                <div class="col-2 d-flex m-0 p-0 max-width-amount">
                  <span>₹4,500</span>
                </div>
                <div class="col-5 pl-1 pr-0 mt-1 discriptionFigure">
                  <span>Funeral Expenses</span>
                </div>
              </div>
              <div class="row breakup-row">
                <div class="col-2 d-flex pr-0 mr-0 w-0">
                  <span>₹450,000 </span>
                </div>
                <div class="col-2 pl-3 pl-lg-1 pl-md-1 pr-0 mt-1 discriptionFigure">
                  <span> PTD</span>
                </div>
                <div class="col-2 d-flex m-0 p-0 max-width-amount">
                  <span>₹4,500</span>
                </div>
                <div class="col-5 pl-1 pr-0 mt-1 discriptionFigure">
                  <span>Lifestyle Modification Benefits</span>
                </div>
              </div>
              <hr />
              <div class="row breakup-row">
                <div class="col-12 h5 mb-0">
                  <span>₹2,500 </span>
                </div>
                <div class="col-12">
                  <span>Total Premium </span>
                </div>
              </div>
            </div>
          </div>
          <!-- Global Personal Guard ends -->
          <!-- Hospital Cash starts here -->
          <div class="col-lg-4 col-md-12 col-sm-12 mobile-padding" :class="{}">
            <div class="p-3 border-card rounded mb-1">
              <div class="d-flex">
                <div class="pl-1">
                  <span class="card-header-color font-weight-bold"
                    >Hospital Cash</span
                  >
                </div>
                <div class="ml-auto">
                  <input 
                    type="checkbox" 
                    class="bgc-checkbox"
                    id="check3" 
                    value="hospitalCash"
                    v-model="crossSellData.healthPlans"
                  />
                  <label
                    class="checkbox-inline form-check-label d-flex justify-content-left"
                    for="check3"
                  ></label>
                </div>
              </div>
              <div class="pt-4"></div>
              <div class="row breakup-row mt-1">
                <div class="col-12 mb-0">
                  <span>₹ 4,500 </span>
                </div>
                <div class="col-12">
                  <span>Per Day Benefit </span>
                </div>
              </div>
              <div class="row breakup-row mt-2">
                <div class="col-12 mb-0 font-weight-bold">
                  <span>14 </span>
                </div>
                <div class="col-12">
                  <span>Number of Days </span>
                </div>
              </div>
              <hr />
              <div class="row breakup-row">
                <div class="col-12 h5 mb-0 font-weight-bold">
                  <span>₹ 2,500 </span>
                </div>
                <div class="col-12">
                  <span>Total Premium </span>
                </div>
              </div>
            </div>
          </div>
          <!-- Hospital Cash ends here -->
          <!-- Sankat Mochan starts here -->
          <div class="col-lg-4 col-md-12 col-sm-12 mobile-padding">
            <div class="p-3 border-card rounded mb-1">
              <div class="d-flex">
                <div class="pt-1">
                  <span class="card-header-color font-weight-bold"
                    >Sankat Mochan</span
                  >
                </div>
                <div class="ml-auto">
                  <input 
                    type="checkbox" 
                    class="bgc-checkbox" 
                    id="check4" 
                    value="sankatMochan"
                    v-model="crossSellData.healthPlans"
                  />
                  <label
                    class="checkbox-inline form-check-label d-flex justify-content-left"
                    for="check4"
                  ></label>
                </div>
              </div>
              <div class="pt-4 sum-insured">
                <span class="mb-0 font-weight-bold">SUM INSURED </span>
              </div>
              <div class="header-underline pt-2"></div>
              <div class="row breakup-row">
                <div class="col-lg-2 col-md-2 col-sm-3 d-flex pr-0 mr-0">
                  <span>₹ 450,000 </span>
                </div>
                <div class="col-2 pl-3 pl-lg-1 pl-md-1 pr-0 mt-1 discriptionFigure">
                  <span> Death</span>
                </div>
              </div>
              <div class="row breakup-row pb-1">
                <div class="col-lg-2 col-md-2 col-sm-3 d-flex pr-0 mr-0">
                  <span>₹ 450,000 </span>
                </div>
                <div class="col-2 pl-3 pl-lg-1 pl-md-1 pr-0 mt-1 discriptionFigure">
                  <span> PTD</span>
                </div>
              </div>
              <hr class="mt-4" />
              <div class="row breakup-row">
                <div class="col-12 h5 mb-0">
                  <span>₹ 2,500 </span>
                </div>
                <div class="col-12">
                  <span>Total Premium </span>
                </div>
              </div>
            </div>
          </div>
          <!-- Sankat Mochan ends here -->
        </div>
        <div
          class="collapse show mt-5 py-0 border borderRadius col-12 bgc-form-box"
        >
          <div class="risk row">
            <!--NUMBER OF PLANS starts -->
            <div
              class="form-group text-center text-lg-left text-md-left border-style-right m-0 p-0 col-lg-3 col-md-3 col-sm-12"
            >
              <p class="text-muted mb-0 pt-4 pl-lg-5 pl-md-5 pl-sm-0">
                NUMBER OF PLANS
              </p>
              <p class="font-weight-bold pl-lg-5 pl-md-5 pl-sm-0 pt-2 pb-4">0{{crossSellData.healthPlans.length}}</p>
            </div>
            <!-- NUMBER OF PLANS ends-->
            <!-- MOTOR PLAN PREMIUM-->
            <div
              class="form-group text-center text-lg-left text-md-left my-4 pl-lg-5 pl-md-4 pl-4 col-lg-3 col-md-3 col-sm-12 p-0"
            >
              <p class="text-muted mb-0">MOTOR PLAN PREMIUM</p>
              <p class="pb-4 mt-2">
                Drive Assure Welcome
                <span class="ml-2">₹3,800</span>
              </p>
            </div>
            <!--MOTOR PLAN PREMIUM ends-->
            <!--HEALTH PLANS PREMIUM starts-->
            <div
              class="form-group text-center text-lg-left text-md-left my-4 pl-lg-5 pl-md-4 pl-4 col-lg-3 col-md-3 col-sm-12 p-0"
            >
              <p class="text-muted mb-0 pb-4">HEALTH PLANS PREMIUM</p>
            </div>
            <!--HEALTH PLANS PREMIUM ends-->
            <!--TOTAL PREMIUM AMOUNT starts -->
            <div
              class="form-group text-lg-right text-md-right text-center border-the-radius text-white total-premium-amount mt-0 mb-0 pt-4 pr-5 col-lg-3 col-md-3 col-sm-12 p-0"
            >
              <p class="mb-1 ml-4 ml-md-0 ml-lg-0 pl-5 pl-lg-0 pl-md-0">
                TOTAL PREMIUM AMOUNT
              </p>
              <h4 class="mb-0 pl-5 pl-md-0 pl-lg-0 pb-4 pb-md-0 pb-lg-0">
                ₹38,000
              </h4>
            </div>
            <!--TOTAL PREMIUM AMOUNT ends -->
          </div>
        </div>
      </div>
     </div>
    </div>
  </div>
</template>

<script>
import FloatLabel from "@/../shared_component/FloatLabel.vue";
import Datepicker from "vuejs-datepicker";
import functions from "@/../../masters/functions.js";
import { reactive, computed , onMounted} from "@vue/composition-api";
import VueTimepicker from "vuejs-timepicker";
export default {
  name: "AdditionalHealthInsurancePlan",
  props: ['crossSellData'],
  components: {
    FloatLabel,
    Datepicker,
    VueTimepicker
  },
  setup(props, context) {
    let state = reactive({
      globalPersonalGaurd: false,
      hospitalCash: false,
      sankatMochan: false,
      showPlans : false,
      workApprovalTime: {
        hh: null,
        mm: null,
        A: null,
      },
    });
    // computed
    const checkMotorParent = computed(()=>{
      let obj = context.root.$store.getters.getMotorParentType;
      if(obj.crossSellFlag){
        return true;
      }
      return false;
    });
    //methods
    const checkError= functions.checkError;
    const isFloat= functions.isFloat;
    const isInputError= functions.isInputError;
    const onlyNumber= functions.onlyNumber;
    function showPlanHealth() {
      // let isError = false;
      // state.showPlans = false;
      // for(let section in props.crossSellData){
      //     let currAttr = props.crossSellData[section];
      //     if(typeof(currAttr) == "object" && currAttr.hasOwnProperty('errorText')){
      //       if(checkError(currAttr,false)){
      //           isError = true;
      //         }
      //     }
      // }
      // if(isError){
      //   setTimeout(function(){
      //     let eleString = ".bgc-error-field:first";
      //     let ele = $(eleString);
      //     $("html, body").stop().animate({scrollTop: ele.offset().top-35 }, 500, 'swing');
      //   },300)
      // }
      // else{
        state.showPlans = true;
      // }
    }
    function checkGlobalPersonalGaurd() {
      state.globalPersonalGaurd = !state.globalPersonalGaurd;
    }
    function crossSellSelected(){
      props.crossSellData.isCrossSellSelected = !props.crossSellData.isCrossSellSelected;
      Object.values(props.crossSellData).forEach(attr => {
        if(typeof(attr)=='object' && !Array.isArray(attr)){
          if(props.crossSellData.isCrossSellSelected){
            delete attr.skip;
          }
          else{
            context.root.$set(attr,'skip',true)
          }
        }
      }); 
    }
    return {
      state,
      checkGlobalPersonalGaurd,
      crossSellSelected,
      showPlanHealth,
      checkError,
      isFloat,
      isInputError,
      onlyNumber,
      checkMotorParent
    };
  },
  directives: {
    evolvews: functions.evolvews,
  }
};
</script>
<style scoped>
@media screen and (min-width: 380px) {
  .overlay{
    /* position: relative; */
    left: calc(100% - 346px);
    font-style: italic;
    font-size: small;
    /* font-weight: normal; */
  }
}
.overlay{
font-size: small;
font-weight: normal;
  }
input[type="checkbox"].bgc-checkbox {
  opacity: 0;
  position: relative;
  top: 17px;
}
.total-premium-amount {
  background-color: #0070be;
}
.checked {
  background-color: #c7c7c7;
}
.discriptionFigure {
  font-weight: bold;
  font-size: 9px;
}

.max-width-amount {
  max-width: 44px;
}
.sum-insured {
  color: #666666;
  font-size: 16px;
}
.breakup-row {
  color: #666666;
  font-size: 12px;
}
.holdingContainer {
  width: 100%;
  border: 1px solid #c6c6c6;
}
.startingHealth {
  color: #333;
}
.get-Health-Plans {
  margin: 7px 32px 6px 0px;
  height: 44px;
  padding: 0 17px;
  font-size: 18px;
  font-weight: bold;
  line-height: 44px;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  border-width: 1px;
  border-style: solid;
  border-radius: 5px;
  font-weight: normal;
}
.border-card {
  border: 1px solid #c6c6c6;
  display: block;
  height: 265px;
  width: 100%;
}
.card-header-color {
  color: #666666;
  font-size: 24px;
}
.header-underline {
  border-bottom: 1px solid #dedede;
  width: 85%;
}
.add-inspection {
  padding-left: 53px;
  position: relative;
  top: 23%;
}
/* for tab in KO-inspection */
.policy-wrap {
  display: flex;
  font-size: 14px;
}
.roll-over {
  position: relative;
  left: 3%;
}
.policy-switch {
  position: relative;
  width: 68%;
  max-width: 392px;
  padding: 0 1rem;
}

.policy-switch:before {
  content: "  ";
  position: absolute;
  left: 0;
  z-index: -1;
  background-color: #b3e5fb;
  padding: 6px 0;
  border-radius: 20px;
  color: #616161;
  font-size: 14px;
  width: 100%;
  min-height: 43px;
}

.policy-switch-label {
  display: inline-block;
  width: 33%;
  padding: 11px 0;
  cursor: pointer;
  transition: color 200ms ease-out;
  z-index: 1;
}

.policy-switch-indicator {
  width: 33%;
  height: 100px;
  margin: 0 5px;
  line-height: 30px;
  background-color: #0070be;
  border-radius: 20px;
  max-height: 30px;
  position: absolute;
  top: 6px;
  left: -7px;
  z-index: -1;
  transition: transform 600ms cubic-bezier(0.02, 0.94, 0.09, 0.97),
    background 300ms cubic-bezier(0.17, 0.67, 0.14, 1.03);
}
.bgc-input {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (max-width: 1217px) {
  .border-card {
    height: auto;
  }
}
@media (max-width: 991px) {
  .mobile-padding {
    padding: 20px;
  }
  .border-card {
    height: auto;
  }
}
@media (max-width: 767px) {
  .largeFigure {
    margin-top: 0.25rem;
    font-weight: 700;
  }
  .mobile-padding {
    padding-top: 20px;
  }
}
@media (max-width: 575px) {
  .mobile-padding {
    padding: 20px;
  }
}
@media (min-width: 760px) {
.border-style-right{
  border-right:1px solid black;
}
}
</style>